import type { ButtonHTMLAttributes } from 'react';

export type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'ink';
export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant; size?: 'sm' | 'md' };

/**
 * Editorial pill buttons. primary = black fill, white label; accent = lavender fill, black label (11.5:1);
 * secondary = 2px black outline pill; ghost = text-only. Use at most one primary/accent per view.
 */
export function Button({ variant = 'secondary', size, className, type = 'button', ...rest }: ButtonProps) {
  return <button {...rest} type={type} data-variant={variant} data-size={size} className={['qm-button', className].filter(Boolean).join(' ')} />;
}
